import { request } from '../base/axios';

class Account {
    constructor ({
        nvwuid,
        login,
        first_name,
        last_name,
        email,
        organizations
    }) {
        this.nvwuid = nvwuid;
        this.login = login;
        this.firstName = first_name;
        this.lastName = last_name;
        this.fullName = `${first_name} ${last_name}`;
        this.email = email;
        this.organizations = organizations;
    }
}

const loadCollaborators = callback =>
    request({
        url: '/restapi/public/v2/trusted-accounts/',
        method: 'GET'
    });

let collaborators = null;
const createCollaboratorsLoader = () =>
    () => collaborators
        ? Promise.resolve(collaborators)
        : loadCollaborators()
            .then(data => {
                collaborators = data.map(u => new Account(u));
                return collaborators;
            });

export default {
    createCollaboratorsLoader,
    loadCollaborators
};
